const tabs = {
  main: function () {
    this.handleTabs();
  },
  slugfy: function (texto) {
    return texto
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  },
  handleTabs: function () {
    const tabNav = document.querySelectorAll('.tab-view__header button');
    const tabContent = document.querySelectorAll('.tab-view .tab-view__content');

    tabNav.forEach((tabButton, index) => {
      const dataId = tabs.slugfy(tabButton.innerText);
      tabButton.setAttribute('data-target', dataId);
      if (tabContent[index]) tabContent[index].setAttribute('id', dataId);
    });

    function handleClick() {
      tabNav.forEach(item => item.classList.remove('active'));
      tabContent.forEach(item => item.classList.remove('active'));

      const target = this.getAttribute('data-target');
      this.classList.add('active');

      document.getElementById(target).classList.add('active');
    }

    tabNav.forEach(button => {
      button.addEventListener('click', handleClick);
    });
  },
};

tabs.main();
